// ================================================= /
// ======   Card Row JS   ========================== /
// ================================================= /

/* global jQuery */

import gsap from 'gsap';

import animation from './animation';
import slider from './slider';

/**
 * Class for controlling the card row element
 */
class DispatchSkinCardRow {

	/**
	 * Constructs the class and sets up instance variables.
	 */
	constructor() {

		this.selector = '.js-card-row';
		this.cardSelector = `${this.selector}__card`;
		this.cardLinkSelector = `${this.cardSelector}-link`;

		this.eventNamespace = 'dispatchSkinCardRow';
		this.duration = 0.5;
		this.stagger = 0.075;
		this.noFocusClass = 'does-not-have-focus';

		this.cardRows = [];
	}

	/**
	 * Initializes the class, sets up events.
	 */
	initialize() {

		this.cardRows = jQuery( this.selector );

		if ( this.cardRows.length ) {

			this.events();
		}
	}

	/**
	 * Wires up events
	 */
	events() {

		this.eventDelegationParent = jQuery( '.site' );

		// Card link hover and focus
		this.eventDelegationParent.on(
			`mouseenter.${this.eventNamespace} focus.${this.eventDelegationParent}`,
			this.cardLinkSelector,
			this.handleCardLinkInteractionStart.bind( this )
		);
		this.eventDelegationParent.on(
			`mouseleave.${this.eventNamespace} blur.${this.eventDelegationParent}`,
			this.cardLinkSelector,
			this.handleCardLinkInteractionEnd.bind( this )
		);

		animation.addHook(
			this.selector,
			this.resolveAnimation.bind( this )
		);
		animation.addHook(
			this.selector,
			this.resetAnimation.bind( this ),
			false
		);
	}

	/* Event handlers --------------------------------------- */

	/**
	 * Handles the link interaction start.
	 */
	handleCardLinkInteractionStart( event ) {

		this.staggerCardNoFocus(
			jQuery( event.target ).closest( this.cardSelector )
				.siblings( this.cardSelector )
		);
	}

	/**
	 * Handles the link interaction end.
	 */
	handleCardLinkInteractionEnd( event ) {

		this.staggerCardNoFocus(
			jQuery( event.target ).closest( this.cardSelector )
				.siblings( this.cardSelector ),
			true
		);
	}

	/**
	 * Adds or removes the no focus class to a list of cards.
	 */
	staggerCardNoFocus( cards, shouldRemove = false ) {

		let index = 0;

		gsap.to(
			cards,
			{
				duration: 0,
				stagger: {
					amount: this.stagger,
					from: index,
					onComplete: function() {
						cards.eq( index )[shouldRemove ? 'removeClass' : 'addClass']( this.noFocusClass );
						index++;
					}.bind( this )
				}
			}
		);
	}

	/**
	 * Animation callbacks
	 */
	resolveAnimation( cardRow ) {

		gsap.to(
			cardRow.find( this.cardSelector ),
			{ duration: 0.5, stagger: { each: 0.15 }, opacity: 1, y: 0, filter: 'grayscale(0%) blur(0px)' }
		);
	}
	resetAnimation( cardRow ) {
	}

}

const cardRow = new DispatchSkinCardRow();
export default cardRow;



// WEBPACK FOOTER //
// ./src/js/inc/card-row.js